// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"364":"fcd92120","498":"800297bb","703":"ff932380","787":"df7b7e15"}[chunkId] + ".chunk.js";
};